import { TextConfigurationTranslation, textConfigurationTranslation } from 'app/area/text-configuration/constants';
import { BlockAccessTranslation } from 'app/area/text-configuration/list/types';
import { objectOfType } from 'app/infrastructure/data/object';

export enum ListType {
  text,
  code
}

export const smResolution = 576;

export const ids = {
  export_to_excel: 'export_to_excel',
  import_from_excel: 'import_from_excel'
};

export const blockAccessTranslation = (listType: ListType,
  translation: TextConfigurationTranslation = objectOfType<TextConfigurationTranslation>()): BlockAccessTranslation => ({
    [ListType.text]: {
      id: textConfigurationTranslation.no_access_to_text_configuration,
      text: translation.no_access_to_text_configuration
    },
    [ListType.code]: {
      id: textConfigurationTranslation.no_access_to_code_descriptions,
      text: translation.no_access_to_code_descriptions
    }
  })[listType] ?? objectOfType<BlockAccessTranslation>();
